<template>
	<div class="bildirimler" style="display:none">
		<table class="contactMeWrapper" @click="PopUpVisible=!PopUpVisible">
			<tr>
				<td>
					<img :src="require('../../public/icons/Contact.svg')" alt="İletişim Simgesi" width="70px">
				</td>
				<td>
					<div>Bana Ulaşın</div>
				</td>
			</tr>
		</table>

		<PopUp
			:isVisible="PopUpVisible"
			@PopUpToggled="PopUpVisible=!PopUpVisible">
		</PopUp>
	</div>
</template>

<script>
	import PopUp from './PopUp';

	export default {
		name: 'ContactMe',
		data() {
			return {
				PopUpVisible: false,
			}
		},

		components: {
			PopUp,
		},
	} 
</script>

<style scoped>
	.bildirimler{
		display: none;
		color: #fff;
		right: 7em;
		margin-bottom: 1em;
		font-size: 20pt;
		font-weight: bold;
		z-index: 10;
		display: block;
		height: 1%;
		float: right;
	}

	.contactMeWrapper{
		position: relative;
		left: 1em;
		cursor: pointer;
	}

	.bildirimPopUp{
		position: absolute;
		right: 1em;
		width: 12em;
		height: auto;
		max-height: 16.5em;
		overflow-x: hidden;
		overflow-y: auto;
		perspective: 1000em;
		padding: 0 1em;
		background-color: #ffffffef;
		border-radius: 15px;
		box-shadow: 0px 5px 7px #333333aa;
		z-index: 10;
	}

	/*============== bildirimPopUp Scrollbar =================*/
	.bildirimPopUp::-webkit-scrollbar {
		width: 15px;
	}

	/* Track */
	.bildirimPopUp::-webkit-scrollbar-track {
		margin-top: .7em;
		margin-bottom: .7em;
	}

	/* Thumb */
	.bildirimPopUp::-webkit-scrollbar-thumb {
		transition: background-color .5s;
		-webkit-transition: background-color .5s;
		-webkit-border-radius: 10px;
		border-radius: 10px;
		background-color: #ADADAD;
		opacity: 0;
	}

	/* Thumb on hover */
	.bildirimPopUp::-webkit-scrollbar-thumb:hover {
		transition: background-color .5s;
		-webkit-transition: background-color .5s;
		background-color: #BBB;
		opacity: .9;
	}

	.bildirimPopUp::-webkit-scrollbar-corner {
		background-color: transparent;
	}
	/*===================================================*/

	.bildirimPopUpdiv::after {
		content: “after”;
	}
	.bildirimPopUpdiv::before {
		content: “before”;
	}
</style>